import { useQuery } from '@tanstack/react-query';
import type { StandardDispenseUnitTypeT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchDispenseUnits } from '../api/getDispenseUnits.js';
import { rxKeys } from './keys.js';

export function dispenseUnitsQueryDefinition() {
  return {
    queryKey: rxKeys.dispenseUnits(),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<StandardDispenseUnitTypeT[]> =>
      fetchDispenseUnits(signal),
    meta: {
      toast: {
        title: 'Could not load dispense units',
        description: 'Dispense units could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function useDispenseUnitsQuery() {
  return useQuery(dispenseUnitsQueryDefinition());
}
